module.exports = __webpack_public_path__ + "static/Firewatch4-f0737edb4f3e4c5170fc96bbbf35b971.webp";